(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class GemGlowFaq extends HTMLElement {
      constructor() {
        super();
        this.handleToggle = this.handleToggle.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
      }

      connectedCallback() {
        if (this.abortController) return;

        this.abortController = new AbortController();
        this.allowMultiple = this.dataset.allowMultiple === 'true';
        this.items = Array.from(this.querySelectorAll('[data-gg-faq-item]'));

        this.items.forEach((item) => {
          item.addEventListener('toggle', this.handleToggle, {
            signal: this.abortController.signal
          });
        });

        document.addEventListener('shopify:block:select', this.handleBlockSelect, {
          signal: this.abortController.signal
        });

        this.enforceSingleOpenItem();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
        this.items = [];
      }

      handleToggle(event) {
        const activeItem = event.currentTarget;

        if (this.allowMultiple || !activeItem.open) return;

        this.items.forEach((item) => {
          if (item !== activeItem && item.open) {
            item.open = false;
          }
        });
      }

      handleBlockSelect(event) {
        if (!(event.target instanceof Element)) return;

        const selectedItem = event.target.closest('[data-gg-faq-item]');

        if (!selectedItem || !this.contains(selectedItem)) return;

        selectedItem.open = true;
      }

      enforceSingleOpenItem() {
        if (this.allowMultiple) return;

        const openItems = this.items.filter((item) => item.open);

        openItems.slice(1).forEach((item) => {
          item.open = false;
        });
      }
    }

    if (!customElements.get('gem-glow-faq')) {
      customElements.define('gem-glow-faq', GemGlowFaq);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gemglow-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '[data-gg-reviews]';
    const instances = new WeakMap();

    const findSections = (root) => {
      if (!root) return [];

      const sections = [];
      if (root instanceof Element && root.matches(sectionSelector)) sections.push(root);
      if (typeof root.querySelectorAll === 'function') {
        root.querySelectorAll(sectionSelector).forEach((section) => sections.push(section));
      }

      return sections;
    };

    const initialise = (section) => {
      if (!section || instances.has(section)) return;

      const filters = Array.from(section.querySelectorAll('[data-review-filter]'));
      const cards = Array.from(section.querySelectorAll('[data-review-card]'));
      const grid = section.querySelector('[data-review-grid]');
      const loadWrap = section.querySelector('[data-load-wrap]');
      const filterStatus = section.querySelector('[data-filter-status]');
      const carouselControls = section.querySelector('[data-carousel-controls]');
      const previousButton = section.querySelector('[data-carousel-prev]');
      const nextButton = section.querySelector('[data-carousel-next]');
      const carouselStatus = section.querySelector('[data-carousel-status]');
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const parsedVisibleCount = Number.parseInt(section.dataset.visibleCount, 10);
      const visibleCount = Number.isFinite(parsedVisibleCount) ? Math.max(1, parsedVisibleCount) : 3;
      const useEmptyFilterFallback = section.dataset.emptyFilterFallback !== 'false';
      const initiallyActiveFilter = filters.find((button) => button.classList.contains('is-active'));
      let activeFilter = initiallyActiveFilter?.dataset.reviewFilter || 'all';
      let expanded = false;
      let matchingCards = [];
      let scrollFrame = null;

      if (!grid || cards.length === 0) {
        instances.set(section, () => {});
        return;
      }

      cards.forEach((card) => card.removeAttribute('data-review-initially-hidden'));

      const setHidden = (element, shouldHide) => {
        if (element && element.hidden !== shouldHide) element.hidden = shouldHide;
      };

      const setDisabled = (button, shouldDisable) => {
        if (button && button.disabled !== shouldDisable) button.disabled = shouldDisable;
      };

      const getLeadingPadding = () => {
        if (!grid) return 0;
        const styles = window.getComputedStyle(grid);
        return Number.parseFloat(styles.paddingInlineStart || styles.paddingLeft) || 0;
      };

      const getCardScrollPosition = (card) => {
        if (!grid || !card) return 0;

        return Math.max(
          0,
          card.getBoundingClientRect().left
            - grid.getBoundingClientRect().left
            + grid.scrollLeft
            - getLeadingPadding()
        );
      };

      const getActiveCardIndex = () => {
        if (!grid || matchingCards.length === 0) return 0;

        const snapEdge = grid.getBoundingClientRect().left + getLeadingPadding();
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        matchingCards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - snapEdge);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      };

      const updateCarouselState = () => {
        const isMobile = mobileQuery.matches;
        const reviewCount = matchingCards.length;
        const activeIndex = reviewCount > 0 ? getActiveCardIndex() : 0;
        const statusText = reviewCount > 0 ? `${activeIndex + 1} / ${reviewCount}` : '0 / 0';

        setHidden(carouselControls, !isMobile || reviewCount <= 1);
        if (carouselStatus && carouselStatus.textContent.trim() !== statusText) {
          carouselStatus.textContent = statusText;
        }
        setDisabled(previousButton, activeIndex <= 0);
        setDisabled(nextButton, reviewCount === 0 || activeIndex >= reviewCount - 1);
      };

      const scheduleCarouselUpdate = () => {
        if (scrollFrame !== null) return;

        scrollFrame = window.requestAnimationFrame(() => {
          updateCarouselState();
          scrollFrame = null;
        });
      };

      const updateFilterStatus = (exactMatchCount, usedFallback) => {
        if (!filterStatus) return;

        const selectedButton = filters.find((button) => button.dataset.reviewFilter === activeFilter);
        const selectedLabel = selectedButton?.textContent.trim() || 'this category';
        const shownCount = matchingCards.length;
        const storyLabel = shownCount === 1 ? 'customer story' : 'customer stories';
        let message = `${shownCount} ${storyLabel} available.`;

        if (activeFilter !== 'all' && exactMatchCount > 0) {
          message = `${exactMatchCount} ${storyLabel} available for ${selectedLabel}.`;
        } else if (activeFilter !== 'all' && usedFallback) {
          message = `No reviews are assigned to ${selectedLabel} yet. Using all ${shownCount} ${storyLabel} instead.`;
        } else if (activeFilter !== 'all' && exactMatchCount === 0) {
          message = `No customer stories are currently assigned to ${selectedLabel}.`;
        }

        filterStatus.classList.toggle('is-visible', activeFilter !== 'all' && exactMatchCount === 0);
        if (filterStatus.textContent !== message) filterStatus.textContent = message;
      };

      const selectFilter = (selectedButton) => {
        activeFilter = selectedButton?.dataset.reviewFilter || 'all';
        expanded = false;

        filters.forEach((button) => {
          const isActive = button === selectedButton;
          button.classList.toggle('is-active', isActive);
          if (button.getAttribute('aria-pressed') !== String(isActive)) {
            button.setAttribute('aria-pressed', String(isActive));
          }
        });
      };

      const refresh = (resetPosition = false) => {
        const isMobile = mobileQuery.matches;
        const exactMatches = cards.filter((card) => {
          const cardCategory = (card.dataset.reviewCategory || '').trim().toLowerCase();
          return activeFilter === 'all' || cardCategory === activeFilter;
        });
        const usedFallback = activeFilter !== 'all' && exactMatches.length === 0 && useEmptyFilterFallback;

        matchingCards = usedFallback ? cards : exactMatches;
        cards.forEach((card) => setHidden(card, true));
        matchingCards.forEach((card, index) => {
          setHidden(card, !isMobile && !expanded && index >= visibleCount);
        });

        setHidden(loadWrap, isMobile || matchingCards.length <= visibleCount || expanded);
        updateFilterStatus(exactMatches.length, usedFallback);

        if (grid) {
          const gridTabIndex = isMobile && matchingCards.length > 1 ? 0 : -1;
          if (grid.tabIndex !== gridTabIndex) grid.tabIndex = gridTabIndex;
          if ((resetPosition || !isMobile) && grid.scrollLeft !== 0) grid.scrollLeft = 0;
        }

        scheduleCarouselUpdate();
      };

      const moveToCard = (index) => {
        if (!grid || matchingCards.length === 0) return;

        const safeIndex = Math.max(0, Math.min(index, matchingCards.length - 1));
        grid.scrollTo({
          left: getCardScrollPosition(matchingCards[safeIndex]),
          behavior: reducedMotionQuery.matches ? 'auto' : 'smooth'
        });
      };

      const handleClick = (event) => {
        if (!(event.target instanceof Element)) return;

        const filterButton = event.target.closest('[data-review-filter]');
        if (filterButton && section.contains(filterButton)) {
          selectFilter(filterButton);
          refresh(true);
          return;
        }

        if (event.target.closest('[data-load-more]')) {
          const firstNewCard = matchingCards[visibleCount];
          expanded = true;
          refresh();

          if (firstNewCard) {
            firstNewCard.tabIndex = -1;
            window.requestAnimationFrame(() => firstNewCard.focus());
          }
          return;
        }

        if (event.target.closest('[data-carousel-prev]')) {
          moveToCard(getActiveCardIndex() - 1);
          return;
        }

        if (event.target.closest('[data-carousel-next]')) {
          moveToCard(getActiveCardIndex() + 1);
        }
      };

      const handleScroll = () => {
        if (mobileQuery.matches) scheduleCarouselUpdate();
      };

      const handleBreakpointChange = () => refresh(true);

      const handleBlockSelect = (event) => {
        if (!(event.target instanceof Element)) return;

        const selectedCard = event.target.closest('[data-review-card]');
        if (!selectedCard || !section.contains(selectedCard)) return;

        const allFilter = filters.find((button) => button.dataset.reviewFilter === 'all');
        selectFilter(allFilter);
        expanded = true;
        refresh(true);

        if (mobileQuery.matches) {
          window.requestAnimationFrame(() => moveToCard(matchingCards.indexOf(selectedCard)));
        }
      };

      section.addEventListener('click', handleClick);
      section.addEventListener('shopify:block:select', handleBlockSelect);
      if (grid) grid.addEventListener('scroll', handleScroll, { passive: true });

      if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', handleBreakpointChange);
      } else {
        mobileQuery.addListener(handleBreakpointChange);
      }

      instances.set(section, () => {
        section.removeEventListener('click', handleClick);
        section.removeEventListener('shopify:block:select', handleBlockSelect);
        if (grid) grid.removeEventListener('scroll', handleScroll);

        if (typeof mobileQuery.removeEventListener === 'function') {
          mobileQuery.removeEventListener('change', handleBreakpointChange);
        } else {
          mobileQuery.removeListener(handleBreakpointChange);
        }

        if (scrollFrame !== null) window.cancelAnimationFrame(scrollFrame);
      });

      refresh(true);
    };

    const initialiseWithin = (root) => findSections(root).forEach(initialise);
    const destroyWithin = (root) => {
      findSections(root).forEach((section) => {
        const destroy = instances.get(section);
        if (destroy) destroy();
        instances.delete(section);
      });
    };

    document.addEventListener('shopify:section:load', (event) => initialiseWithin(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));

    initialiseWithin(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (() => {
    if (window.PremiumProductCards && typeof window.PremiumProductCards.initialise === 'function') {
      window.PremiumProductCards.initialise(document);
      return;
    }

    const rootSelector = 'collection-component[data-premium-color-grid="true"]';
    const cardSelector = '[data-premium-product-card][data-auto-card-color="true"]';
    const cardManagers = new WeakMap();
    const queuedCards = new WeakSet();
    const sampleSize = 20;
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d', { willReadFrequently: true });

    canvas.width = sampleSize;
    canvas.height = sampleSize;

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const runWhenIdle = (callback) => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout: 400 });
      } else {
        window.setTimeout(callback, 0);
      }
    };

    const getPremiumColor = (red, green, blue) => {
      const neutral = (red + green + blue) / 3;
      const whiteMix = 0.43;

      red = ((red * 0.72) + (neutral * 0.28)) * (1 - whiteMix) + (255 * whiteMix);
      green = ((green * 0.72) + (neutral * 0.28)) * (1 - whiteMix) + (255 * whiteMix);
      blue = ((blue * 0.72) + (neutral * 0.28)) * (1 - whiteMix) + (255 * whiteMix);

      return [
        clamp(Math.round(red), 132, 239),
        clamp(Math.round(green), 132, 239),
        clamp(Math.round(blue), 132, 239)
      ];
    };

    const useFallback = (card) => {
      card.dataset.colorReady = 'fallback';
    };

    const calculateCardColor = (card, image) => {
      if (!context || !image.naturalWidth || !image.naturalHeight || !card.isConnected) {
        useFallback(card);
        return;
      }

      try {
        const sourceHeight = Math.max(1, Math.round(image.naturalHeight * 0.32));
        const sourceY = Math.max(0, image.naturalHeight - sourceHeight);

        context.clearRect(0, 0, sampleSize, sampleSize);
        context.drawImage(
          image,
          0,
          sourceY,
          image.naturalWidth,
          sourceHeight,
          0,
          0,
          sampleSize,
          sampleSize
        );

        const pixels = context.getImageData(0, 0, sampleSize, sampleSize).data;
        let red = 0;
        let green = 0;
        let blue = 0;
        let totalWeight = 0;

        for (let index = 0; index < pixels.length; index += 4) {
          const alpha = pixels[index + 3] / 255;
          if (alpha < 0.3) continue;

          const pixelRed = pixels[index];
          const pixelGreen = pixels[index + 1];
          const pixelBlue = pixels[index + 2];
          const brightness = (pixelRed * 0.299) + (pixelGreen * 0.587) + (pixelBlue * 0.114);
          if (brightness < 12 || brightness > 247) continue;

          const saturation = Math.max(pixelRed, pixelGreen, pixelBlue) - Math.min(pixelRed, pixelGreen, pixelBlue);
          const weight = alpha * (1 + saturation / 620);

          red += pixelRed * weight;
          green += pixelGreen * weight;
          blue += pixelBlue * weight;
          totalWeight += weight;
        }

        if (!totalWeight) {
          useFallback(card);
          return;
        }

        const premiumColor = getPremiumColor(
          red / totalWeight,
          green / totalWeight,
          blue / totalWeight
        );

        card.style.setProperty('--ppc-card-color', `rgb(${premiumColor.join(', ')})`);
        card.dataset.colorReady = 'true';
      } catch (error) {
        useFallback(card);
      }
    };

    const prepareCard = (card) => {
      if (card.dataset.colorReady) return;

      if (card.style.getPropertyValue('--ppc-card-color').trim()) {
        card.dataset.colorReady = 'true';
        return;
      }

      const image = card.querySelector('.ppc-card__image--primary');
      if (!image) {
        useFallback(card);
        return;
      }

      const calculate = () => runWhenIdle(() => calculateCardColor(card, image));

      if (image.complete) {
        if (image.naturalWidth) {
          calculate();
        } else {
          useFallback(card);
        }
        return;
      }

      image.addEventListener('load', calculate, { once: true });
      image.addEventListener('error', () => useFallback(card), { once: true });
    };

    const cardObserver = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            cardObserver.unobserve(entry.target);
            prepareCard(entry.target);
          });
        }, { rootMargin: '400px 0px' })
      : null;

    const queueCard = (card, manager) => {
      if (card.dataset.colorReady || queuedCards.has(card)) return;

      queuedCards.add(card);
      manager.cards.add(card);

      if (cardObserver) {
        cardObserver.observe(card);
      } else {
        prepareCard(card);
      }
    };

    const queueWithin = (node, manager) => {
      if (!(node instanceof Element)) return;
      if (node.matches(cardSelector)) queueCard(node, manager);
      node.querySelectorAll(cardSelector).forEach((card) => queueCard(card, manager));
    };

    const forgetWithin = (node, manager) => {
      if (!(node instanceof Element)) return;

      const cards = node.matches(cardSelector)
        ? [node, ...node.querySelectorAll(cardSelector)]
        : node.querySelectorAll(cardSelector);

      cards.forEach((card) => {
        if (cardObserver) cardObserver.unobserve(card);
        manager.cards.delete(card);
        queuedCards.delete(card);
      });
    };

    const setupRoot = (root) => {
      if (cardManagers.has(root)) return;

      const manager = { cards: new Set(), observer: null };
      manager.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.removedNodes.forEach((node) => forgetWithin(node, manager));
          mutation.addedNodes.forEach((node) => queueWithin(node, manager));
        });
      });

      cardManagers.set(root, manager);
      root.querySelectorAll(cardSelector).forEach((card) => queueCard(card, manager));
      manager.observer.observe(root, { childList: true, subtree: true });
    };

    const rootsWithin = (scope) => {
      if (!scope || typeof scope.querySelectorAll !== 'function') return [];

      const roots = [];
      if (scope instanceof Element && scope.matches(rootSelector)) roots.push(scope);
      scope.querySelectorAll(rootSelector).forEach((root) => roots.push(root));
      return roots;
    };

    const initialise = (scope = document) => rootsWithin(scope).forEach(setupRoot);
    const destroy = (scope) => {
      rootsWithin(scope).forEach((root) => {
        const manager = cardManagers.get(root);
        if (!manager) return;

        manager.observer.disconnect();
        manager.cards.forEach((card) => {
          if (cardObserver) cardObserver.unobserve(card);
          queuedCards.delete(card);
        });
        manager.cards.clear();
        cardManagers.delete(root);
      });
    };

    window.PremiumProductCards = { initialise };
    document.addEventListener('shopify:section:load', (event) => initialise(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroy(event.target));

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
    } else {
      initialise();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '.gg-related[data-section-id]';
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

    const findSections = (root) => {
      if (!root) return [];

      const sections = [];
      if (root instanceof Element && root.matches(sectionSelector)) sections.push(root);
      if (typeof root.querySelectorAll === 'function') {
        root.querySelectorAll(sectionSelector).forEach((section) => sections.push(section));
      }
      return sections;
    };

    const updateGridTabStop = (section) => {
      const grid = section.querySelector('[data-related-grid]');
      if (!grid) return;

      if (section.dataset.mobileSlider === 'true') {
        grid.tabIndex = mobileQuery.matches ? 0 : -1;
      } else {
        grid.removeAttribute('tabindex');
      }
    };

    const ensureProductFormScript = (section) => {
      const scriptSource = section.dataset.productFormScript;
      if (!scriptSource || !section.querySelector('product-form')) return;
      if ('customElements' in window && window.customElements.get('product-form')) return;

      const resolvedSource = new URL(scriptSource, document.baseURI).href;
      const scriptAlreadyExists = Array.from(document.scripts).some((script) => script.src === resolvedSource);
      if (scriptAlreadyExists) return;

      const script = document.createElement('script');
      script.src = resolvedSource;
      script.defer = true;
      script.dataset.ggProductFormLoader = 'true';
      document.head.appendChild(script);
    };

    const initialiseWithin = (root) => {
      findSections(root).forEach((section) => {
        updateGridTabStop(section);
        ensureProductFormScript(section);
      });
    };

    document.addEventListener('pointerover', (event) => {
      if (!hoverQuery.matches || !(event.target instanceof Element)) return;

      const mediaLink = event.target.closest('[data-secondary-image-container]');
      if (!mediaLink || (event.relatedTarget instanceof Node && mediaLink.contains(event.relatedTarget))) return;

      const template = mediaLink.querySelector('template[data-secondary-image-template]');
      if (!template) return;

      const fragment = template.content.cloneNode(true);
      const secondaryImage = fragment.querySelector('.gg-card__image--secondary');
      template.replaceWith(fragment);

      if (!secondaryImage) return;
      const markReady = () => mediaLink.classList.add('is-secondary-ready');
      if (secondaryImage.complete && secondaryImage.naturalWidth > 0) {
        markReady();
      } else {
        secondaryImage.addEventListener('load', markReady, { once: true });
      }
    }, { passive: true });

    document.addEventListener('shopify:section:load', (event) => initialiseWithin(event.target));

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', () => initialiseWithin(document));
    } else {
      mobileQuery.addListener(() => initialiseWithin(document));
    }

    initialiseWithin(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dh-collection-tabs')) {
    class DhCollectionTabs extends HTMLElement {
      constructor() {
        super();

        this.isInitialized = false;
        this.tabs = [];
        this.panels = [];
        this.tracks = [];
        this.trackScrollHandlers = new Map();
        this.scrollFrames = new Map();
        this.resizeObserver = null;
        this.revealObserver = null;
        this.motionTimer = null;
        this.panelAnimationTimer = null;

        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
        this.handleResize = this.handleResize.bind(this);
      }

      connectedCallback() {
        if (this.isInitialized) return;

        this.isInitialized = true;
        this.tabs = Array.from(this.querySelectorAll('.dh-tab'));
        this.panels = Array.from(this.querySelectorAll('.dh-tab-content'));
        this.tracks = [];

        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeydown);
        this.addEventListener('shopify:block:select', this.handleBlockSelect);
        this.initializeMotion();

        this.querySelectorAll('.dh-products').forEach((track) => {
          this.registerTrack(track);
        });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            this.updateVisibleSlider();
          });

          this.resizeObserver.observe(this);
        } else {
          window.addEventListener('resize', this.handleResize, { passive: true });
        }

        const selectedTab = this.tabs.find(
          (tab) => tab.getAttribute('aria-selected') === 'true'
        ) || this.tabs[0];

        if (selectedTab) {
          this.activateTab(selectedTab, {
            moveFocus: false,
            scrollTab: false,
            animatePanel: false
          });
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKeydown);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);
        window.removeEventListener('resize', this.handleResize);

        this.trackScrollHandlers.forEach((handler, track) => {
          track.removeEventListener('scroll', handler);
        });

        this.scrollFrames.forEach((frame) => {
          cancelAnimationFrame(frame);
        });

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
          this.resizeObserver = null;
        }

        if (this.revealObserver) {
          this.revealObserver.disconnect();
          this.revealObserver = null;
        }

        if (this.motionTimer) {
          window.clearTimeout(this.motionTimer);
          this.motionTimer = null;
        }

        if (this.panelAnimationTimer) {
          window.clearTimeout(this.panelAnimationTimer);
          this.panelAnimationTimer = null;
        }

        this.classList.remove('dh-motion-ready', 'is-visible', 'dh-ambient-motion');

        this.trackScrollHandlers.clear();
        this.scrollFrames.clear();
        this.tabs = [];
        this.panels = [];
        this.tracks = [];
        this.isInitialized = false;
      }

      get prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      initializeMotion() {
        if (this.dataset.dhMotion === 'false' || this.prefersReducedMotion) return;

        this.classList.add('dh-motion-ready');

        const reveal = () => {
          if (this.revealObserver) {
            this.revealObserver.disconnect();
            this.revealObserver = null;
          }

          requestAnimationFrame(() => {
            this.classList.add('is-visible', 'dh-ambient-motion');

            this.motionTimer = window.setTimeout(() => {
              this.classList.remove('dh-motion-ready', 'dh-ambient-motion');
              this.motionTimer = null;
            }, 1900);
          });
        };

        if ('IntersectionObserver' in window) {
          this.revealObserver = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) reveal();
            },
            {
              rootMargin: '0px 0px -5% 0px',
              threshold: 0.08
            }
          );

          this.revealObserver.observe(this);
        } else {
          reveal();
        }
      }

      handleClick(event) {
        const tab = event.target.closest('.dh-tab');

        if (tab && this.contains(tab)) {
          this.activateTab(tab, {
            moveFocus: false,
            scrollTab: true
          });
          return;
        }

        const sliderButton = event.target.closest(
          '[data-slider-prev], [data-slider-next]'
        );

        if (!sliderButton || !this.contains(sliderButton)) return;

        const shell = sliderButton.closest('.dh-products-shell');
        const track = shell ? shell.querySelector('.dh-products') : null;

        if (!track) return;

        const direction = sliderButton.hasAttribute('data-slider-prev') ? -1 : 1;
        const isRtl = getComputedStyle(track).direction === 'rtl';
        const amount = this.getScrollAmount(track) * direction * (isRtl ? -1 : 1);

        track.scrollBy({
          left: amount,
          behavior: this.prefersReducedMotion ? 'auto' : 'smooth'
        });
      }

      handleKeydown(event) {
        const currentTab = event.target.closest('.dh-tab');

        if (!currentTab || !this.contains(currentTab)) return;

        const currentIndex = this.tabs.indexOf(currentTab);

        if (currentIndex < 0) return;

        const isRtl = getComputedStyle(this).direction === 'rtl';
        let nextIndex = null;

        switch (event.key) {
          case 'ArrowRight':
            nextIndex = isRtl
              ? (currentIndex - 1 + this.tabs.length) % this.tabs.length
              : (currentIndex + 1) % this.tabs.length;
            break;
          case 'ArrowLeft':
            nextIndex = isRtl
              ? (currentIndex + 1) % this.tabs.length
              : (currentIndex - 1 + this.tabs.length) % this.tabs.length;
            break;
          case 'Home':
            nextIndex = 0;
            break;
          case 'End':
            nextIndex = this.tabs.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();

        this.activateTab(this.tabs[nextIndex], {
          moveFocus: true,
          scrollTab: true
        });
      }

      handleBlockSelect(event) {
        const selectedTab = event.target.closest('.dh-tab');

        if (!selectedTab || !this.contains(selectedTab)) return;

        this.activateTab(selectedTab, {
          moveFocus: false,
          scrollTab: true
        });
      }

      handleResize() {
        this.updateVisibleSlider();
      }

      registerTrack(track) {
        if (!track || this.trackScrollHandlers.has(track)) return;

        const scrollHandler = () => {
          const existingFrame = this.scrollFrames.get(track);

          if (existingFrame) {
            cancelAnimationFrame(existingFrame);
          }

          const frame = requestAnimationFrame(() => {
            this.scrollFrames.delete(track);
            this.updateSlider(track.closest('.dh-tab-content'));
          });

          this.scrollFrames.set(track, frame);
        };

        track.addEventListener('scroll', scrollHandler, { passive: true });
        this.trackScrollHandlers.set(track, scrollHandler);
        this.tracks.push(track);
      }

      hydratePanel(panel) {
        if (!panel || panel.dataset.dhHydrated === 'true') return;

        const template = panel.querySelector('template[data-dh-panel-template]');

        if (!template) {
          panel.dataset.dhHydrated = 'true';
          return;
        }

        panel.appendChild(template.content.cloneNode(true));
        template.remove();
        panel.dataset.dhHydrated = 'true';

        panel.querySelectorAll('.dh-products').forEach((track) => {
          this.registerTrack(track);
        });
      }

      activateTab(selectedTab, options = {}) {
        if (!selectedTab || !this.tabs.includes(selectedTab)) return;

        const {
          moveFocus = false,
          scrollTab = true,
          animatePanel = true
        } = options;
        const targetId = selectedTab.getAttribute('aria-controls');
        const activePanel = this.panels.find((panel) => panel.id === targetId);

        this.hydratePanel(activePanel);

        this.tabs.forEach((tab) => {
          const isSelected = tab === selectedTab;
          tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          tab.tabIndex = isSelected ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          const isActive = panel === activePanel;
          panel.hidden = !isActive;

          if (!isActive) {
            panel.classList.remove('is-entering');
          }
        });

        if (activePanel && animatePanel && !this.prefersReducedMotion) {
          if (this.panelAnimationTimer) {
            window.clearTimeout(this.panelAnimationTimer);
          }

          activePanel.classList.remove('is-entering');
          void activePanel.offsetWidth;
          activePanel.classList.add('is-entering');

          this.panelAnimationTimer = window.setTimeout(() => {
            activePanel.classList.remove('is-entering');
            this.panelAnimationTimer = null;
          }, 450);
        }

        if (moveFocus) {
          try {
            selectedTab.focus({ preventScroll: true });
          } catch (error) {
            selectedTab.focus();
          }
        }

        if (scrollTab) {
          selectedTab.scrollIntoView({
            block: 'nearest',
            inline: window.matchMedia('(max-width: 768px)').matches ? 'center' : 'nearest',
            behavior: this.prefersReducedMotion ? 'auto' : 'smooth'
          });
        }

        requestAnimationFrame(() => {
          this.updateSlider(activePanel);
        });
      }

      getScrollAmount(track) {
        const firstCard = track.querySelector('.dh-card');

        if (!firstCard) {
          return Math.max(track.clientWidth * 0.8, 280);
        }

        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        const cardWidth = firstCard.getBoundingClientRect().width;
        const cardStep = cardWidth + gap;
        const visibleCards = Math.max(
          1,
          Math.floor((track.clientWidth + gap) / cardStep)
        );

        return cardStep * visibleCards;
      }

      updateVisibleSlider() {
        const activePanel = this.panels.find((panel) => !panel.hidden);
        this.updateSlider(activePanel);
      }

      updateSlider(panel) {
        if (!panel || panel.hidden) return;

        const shell = panel.querySelector('.dh-products-shell');
        const track = panel.querySelector('.dh-products');

        if (!shell || !track) return;

        const previousButton = shell.querySelector('[data-slider-prev]');
        const nextButton = shell.querySelector('[data-slider-next]');
        const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const currentScroll = Math.abs(track.scrollLeft);
        const hasOverflow = maximumScroll > 5;

        shell.classList.toggle('dh-no-scroll', !hasOverflow);

        if (previousButton) {
          previousButton.disabled = !hasOverflow || currentScroll <= 5;
        }

        if (nextButton) {
          nextButton.disabled = !hasOverflow || currentScroll >= maximumScroll - 5;
        }
      }
    }

    customElements.define('dh-collection-tabs', DhCollectionTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
